<!-- 月度排名表-->
<template>
  <div id="deviceManage">
    <div class="device-quest">
      <el-form
        :inline="true"
        :model="msg"
        class="demo-form-inline"
        size="small"
      >
        <el-form-item label="时间：">
          <template v-if="msg.rankType == 0">
            <el-date-picker
              v-model="date"
              type="monthrange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            ></el-date-picker>
          </template>
          <template v-else-if="msg.rankType == 1">
            <date-picker
              v-model="date[0]"
              type="quarter"
              format="yyyy-QQ"
              value-format="yyyyQ"
              placeholder="开始季度"
            />
            至
            <date-picker
              v-model="date[1]"
              type="quarter"
              format="yyyy-QQ"
              value-format="yyyyQ"
              placeholder="结束季度"
            />
          </template>
          <template v-else-if="msg.rankType == 2">
            <el-date-picker
              v-model="date[0]"
              type="year"
              align="right"
              placeholder="开始年份"
            ></el-date-picker>
            至
            <el-date-picker
              v-model="date[1]"
              type="year"
              align="right"
              placeholder="结束年份"
            ></el-date-picker>
          </template>
        </el-form-item>
        <el-form-item>
          <el-button @click="onGetRank">查询</el-button>
          <el-button type="primary" @click="refresh">重置</el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-model="msg.rankType" @tab-click="refresh">
        <el-tab-pane label="月度排名" name="0"></el-tab-pane>
        <el-tab-pane label="季度排名" name="1"></el-tab-pane>
        <el-tab-pane label="年度排名" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <el-row v-loading="loading">
    <div id="deviceTop" class="deviceManage-box">
      <p class="deviceManage-title">{{ titleList[msg.rankType] }}表</p>
      <div class="deviceManage-header">
        <el-row>
          <el-col :span="4">
            <div>
              {{
                msg.rankType == 0 ? "月份" : msg.rankType == 1 ? "季度" : "年份"
              }}
            </div>
          </el-col>
          <el-col :span="5">
            <div>品牌</div>
          </el-col>
          <el-col :span="5">
            <div>得分</div>
          </el-col>
          <el-col :span="5">
            <div>等级</div>
          </el-col>
          <el-col :span="5">
            <div>{{ titleList[msg.rankType] }}</div>
          </el-col>
        </el-row>
      </div>
      <template v-if="deviceList.length > 0 && deviceList[0][1].length > 0">
        <div
          class="deviceManage-items"
          v-for="item in deviceList"
          :key="item[0]"
        >
          <el-row class="device-content">
            <el-col :span="4">
              <div>{{ item[0] }}</div>
            </el-col>
            <el-col :span="5">
              <div :class="msg.rankType == 0 ? 'device-name' : ''">
                <p
                  @click="onJump(name)"
                  v-for="name in item[1]"
                  :key="name.brandId"
                >
                  {{ name.brandName }}
                </p>
              </div>
            </el-col>
            <el-col :span="5">
              <div>
                <p v-for="sum in item[1]" :key="sum.brandId">
                  {{ Number((100 - sum.score).toFixed(2)) }}
                </p>
              </div>
            </el-col>
            <el-col :span="5">
              <div>
                <p v-for="type in item[1]" :key="type.brandId">
                  {{ type.grade >0 ? "不合格" : "合格" }}
                  <img
                    @click="getTip(type)"
                    src="@/assets/image/tui.png"
                    class="tip"
                    v-if="type.isOut && msg.rankType == 0"
                  />
                </p>
              </div>
            </el-col>
            <el-col :span="5">
              <div>
                <p v-for="(ranking, index) in item[1]" :key="ranking.brandId">
                  {{ index + 1 }}
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <div v-else class="deviceManage-items">
        <el-row class="device-content">
          <el-col :span="24">
            <div>
              <p>暂无数据...</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    </el-row>
  </div>
</template>

<script>
import Api from '@/api'
import DatePicker from '@thtf/element-datepicker'
export default {
  name: 'rate',
  components: {
    DatePicker
  },
  computed: {
    selfAreaId() {
      return this.$store.getters.selfAreaId
    },
    deviceList() {
      return Object.entries(this.deviceData).filter((val) => {
        return val[1].length > 0
      })
    }
  },
  data() {
    return {
      loading: false,
      titleList: ['月度排名', '季度排名', '年度排名'],
      date: [],
      msg: {
        beginTime: null,
        endTime: null,
        rankType: '0'
      },
      time: '',
      deviceData: {}
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    onGetRank() {
      this.loading = true
      let param = {}
      if (this.date && this.date.length) {
        if (this.msg.rankType == 0) {
          param = {
            type: 'month',
            start: this.dayjs(this.date[0]).format('YYYYMM'),
            end: this.dayjs(this.date[1]).format('YYYYMM')
          }
        } else if (this.msg.rankType == 1) {
          if (Number(this.date[1]) < Number(this.date[0])) {
            this.$message.error('结束季度小于开始季度')
            return
          }
          param = {
            type: 'quarter',
            start: this.date[0],
            end: this.date[1]
          }
        } else if (this.msg.rankType == 2) {
          if (Number(this.date[1]) < Number(this.date[0])) {
            this.$message.error('结束年份小于开始年份')
            return
          }
          param = {
            type: 'year',
            start: this.dayjs(this.date[0]).format('YYYY'),
            end: this.dayjs(this.date[1]).format('YYYY')
          }
        }
      }
      Api.getRank({ selfAreaId: this.selfAreaId, ...param }).then(
        ({ data }) => {
          this.loading = false
          this.deviceData = data
        }
      )
    },
    onJump(data) {
      if (!this.msg.rankType) {
        return
      }
      console.log(data, 1111)
      this.$router.push({
        name: 'grade',
        params: { id: this.selfAreaId },
        query: {
          data: JSON.stringify(data)
        }
      })
    },
    refresh() {
      this.date = [new Date(), new Date()]
      if (this.msg.rankType == 1) {
        const time = this.dayjs().format('YYYY') + this.dayjs().quarter()
        this.date = [time, time]
      }
      this.onGetRank()
    },
    getTip(data) {
      Api.getBrandOut({
        selfAreaId: this.selfAreaId,
        brandId: data.brandId,
        type: ['month', 'quarter', 'year'][this.msg.rankType],
        now: data.workDate
      }).then(({ data }) => {
        const reason = []
        if (data.length > 0) {
          data.forEach((val) => {
            val.infoBak = JSON.parse(val.infoBak)
            console.log(val.infoBak)
            if (val.infoBak.examineInfo) {
              val.infoBak.examineInfo = JSON.parse(val.infoBak.examineInfo)
              const name = val.infoBak.examineInfo.title
              if (!reason.includes(name)) {
                reason.push(name)
              }
            }
            if (val.source) {
              const name = { 100: '重点区域偏多调度', 150: '普通区域偏多调度', 200: '站外还车调度', 250: '非法车辆调度' }[val.source]
              if (!reason.includes(name)) {
                reason.push(name)
              }
            }
          })
        }
        this.$alert(
          `<p>违反了“<span style='color:#1F8FFB'>${reason.join(
            ','
          )}</span>”考核内容设置，按照规则触发退市。</p>`,
          '退市说明',
          {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false
          }
        )
      })
    }
  },
  watch: {}
}
</script>
<style scoped lang="less">
#deviceManage {
  overflow: auto;

  /*---滚动条大小--*/
  .site-Highlight {
    color: #f56c6c !important;
  }

  .device-quest {
    background: #fff;
    padding: 24px 16px 0;
    margin: 16px 20px 0;

    /deep/ .el-tabs__header {
      margin: 0 0 1px;
    }
  }

  .deviceManage {
    &-box {
      padding: 10px 16px;
      line-height: 30px;
    }

    &-title {
      font-size: 18px;
      line-height: 50px;
      font-weight: 600;
      text-align: center;
    }

    &-pagination {
      text-align: right;
      width: 100%;
      height: 100%;
      // background: #fff;
      float: left;
      margin: 0.1rem 0;
      padding: 16px 0;

      /deep/ .el-select {
        line-height: 28px;
      }
    }

    &-header {
      line-height: 20px;
      padding: 12px 0 12px;
      font-size: 14px;
      background: #fafafc;
      text-align: center;

      p {
        font-size: 14px;
      }
    }

    &-items {
      text-align: center;
      width: 100%;
      height: 100%;
      background: #fff;
      color: #666;
      float: left;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      -webkit-box-shadow: 2px 2px 2px #ddd;
      -moz-box-shadow: 2px 2px 2px #ddd;
      box-shadow: 2px 2px 2px #ddd;
      margin: 10px 0 0;
      padding: 12px 0;
      position: relative;

      .device-name {
        color: #409eff;
        cursor: pointer;
      }

      .device-content {
        display: flex;
        align-items: center;

        p {
          position: relative;
          font-size: 14px;
          line-height: 54px;
          border-bottom: 1px solid #eee;

          &:last-child {
            border: 0;
          }
        }

        img {
          position: absolute;
          vertical-align: middle;
          right: 0;
        }
      }

      &:last-child {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
